import { updateInfoStorage, userStorage } from '@/configs/storages';

export async function clearAll() {
  const commitHash = await updateInfoStorage.getItem('commitHash');
  localStorage.clear();
  updateInfoStorage.setItem('commitHash', commitHash);
  await clearDB();
}

export async function clearDB() {
  userStorage.setItem('clear_DB_flag', true);
  location.reload();
}

export async function clearOPFS() {
  await (async function clear(entry) {
    for await (const value of (entry as any).values()) {
      if (value.kind === 'directory') {
        await clear(value);
      }
      await value.remove();
    }
  })(await navigator.storage.getDirectory());
}
